/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListLivestockMeasurementsByOrganizationQueryResponse, ListLivestockMeasurementsByOrganizationPathParams, ListLivestockMeasurementsByOrganizationQueryParams, ListLivestockMeasurementsByOrganization400, ListLivestockMeasurementsByOrganization401, ListLivestockMeasurementsByOrganization403, ListLivestockMeasurementsByOrganization404, ListLivestockMeasurementsByOrganization409, ListLivestockMeasurementsByOrganization500 } from "../../types/livestockController/ListLivestockMeasurementsByOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListLivestockMeasurementsByOrganizationUrl(organizationId: ListLivestockMeasurementsByOrganizationPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/livestock-measurements` as const }
  return res
}

/**
 * @summary List animal measurements across the organization (optionally one farm via ?establishmentId)
 * {@link /api/organizations/:organizationId/livestock-measurements}
 */
export async function listLivestockMeasurementsByOrganization(organizationId: ListLivestockMeasurementsByOrganizationPathParams["organizationId"], params?: ListLivestockMeasurementsByOrganizationQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListLivestockMeasurementsByOrganizationQueryResponse, ResponseErrorConfig<ListLivestockMeasurementsByOrganization400 | ListLivestockMeasurementsByOrganization401 | ListLivestockMeasurementsByOrganization403 | ListLivestockMeasurementsByOrganization404 | ListLivestockMeasurementsByOrganization409 | ListLivestockMeasurementsByOrganization500>, unknown>({ method : "GET", url : getListLivestockMeasurementsByOrganizationUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}